<template>
  <div id="product">
    <section class="px20 product-top-section">
      <div class="container product-container">
        <section class="row m0">
          <div class="col-tablet col-md-7 center-xs middle-xs image relative h-100">
            <breadcrumbs
              class="pt20 pb20 align-left lh25 breadcrumbs"
            />
            <LazyHydrate when-idle>
              <div class="tile">
                <!-- <span v-if="isOnSale" class="tile__label sale">{{ $t('On Sale') }}</span> -->
                <span v-if="isRetailPromo" class="tile__label retailPromo">{{ $t('Taniej niz w kiosku') }}</span>
                <span v-else-if="isNew" class="tile__label new">{{ $t('New') }}</span>
                <span v-else-if="isBestseller" class="tile__label bestseller">{{ $t('Bestseller') }}</span>
                <special-price-tile
                  class="tile__label special mt10"
                  :product="getCurrentProduct"
                  :custom-options="getCurrentCustomOptions"
                  :omnibus-price="omnibusPriceMap[getCurrentProduct.sku]"
                />
              </div>
            </LazyHydrate>
            <LazyHydrate when-idle>
              <product-gallery
                :offline="getOfflineImage"
                :gallery="getProductGallery"
                :large="getProductLargeGallery"
                :configuration="getCurrentProductConfiguration"
                :product="getCurrentProduct"
              />
            </LazyHydrate>
          </div>
          <div class="col-tablet col-md-5 data pl30 pr0">
            <div class="relative py15">
              <logo-button v-if="getCurrentProduct.brand && !$device.isMobile" :brand="getCurrentProduct.brand" />
              <div class="name-wrapper">
                <p
                  class="weight-500 my20 cl-black secondary-font product-name"
                  data-testid="productName"
                >
                  <span>{{ getCurrentProduct.name | htmlDecode }}</span>
                </p>
              </div>
              <div class="row m0 pb10" v-show="reviewStar">
                <div class="col-xs-12 p0">
                  <div class="star-rating flex middle-xs between-xs wrap">
                    <div class="flex middle-xs">
                      <div>
                        <i class="star-placeholder icon-star cl-silver" :class="{'cl-main': reviewStar >= 1}" v-if="reviewStar" />
                        <i class="star-placeholder icon-star cl-silver" :class="{'cl-main': reviewStar >= 2}" v-if="reviewStar" />
                        <i class="star-placeholder icon-star cl-silver" :class="{'cl-main': reviewStar >= 3}" v-if="reviewStar" />
                        <i class="star-placeholder icon-star cl-silver" :class="{'cl-main': reviewStar >= 4}" v-if="reviewStar" />
                        <i class="star-placeholder icon-star cl-silver" :class="{'cl-main': reviewStar >= 5}" v-if="reviewStar" />
                      </div>
                      <span class="pl5" v-if="reviewCount >= 1">{{ reviewCount }} recenzji</span>
                    </div>
                    <logo-button v-if="getCurrentProduct.brand && $device.isMobile" :brand="getCurrentProduct.brand" />
                  </div>
                </div>
              </div>
              <AddToWishlist :product="getCurrentProduct" class="wishlist-btn" />
              <div
                class="mb10 fs-medium-small cl-black"
                :content="getCurrentProduct.sku"
              >
                {{ $t('SKU: {sku}', { sku: getCurrentProduct.sku }) }}
                <web-share
                  :title="getCurrentProduct.name | htmlDecode"
                  text="Check this product!"
                  class="web-share"
                />
              </div>
              <div class="row promoted-badge bg-cl-main" v-if="promoted && timerCount">
                <p class="promoted-title">
                  <span v-show="getCurrentProduct.book_premiere">
                    Data premiery
                  </span>
                  <span v-show="getCurrentProduct.shipping_schedule">
                    Następna wysyłka za
                  </span>
                </p>
                <div class="col-xs-6 col-md-5 counter">
                  <p class="promoted-countdown">
                    {{ timerCount }}
                  </p>
                </div>
              </div>
            </div>
            <h4
              v-show="bookPublicationForm && getCurrentUpsellProduct"
              class="mt0 fs16"
            >
              Wybierz format dla siebie.
            </h4>
            <div class="border-section mb25 flex middle-xs" v-if="getCurrentProduct.type_id !== 'grouped'">
              <div class="bookPublicationFormImage hidden-xs">
                <img v-show="!bookPublicationForm && (getCurrentProduct.type_id === 'subscription' || getCurrentProduct.type_id === 'bundle') && !getCurrentProduct.is_virtual_bundle" v-lazy="'/assets/product-tabs/prenumerata.svg'" height="70" alt="Oficjalny sklep wydawnictwa Burda Media Polska">
                <img v-show="bookPublicationForm" v-lazy="'/assets/product-tabs/' + publicationFromPretier + '.svg'" height="70" alt="Oficjalny sklep wydawnictwa Burda Media Polska">
              </div>
              <div class="border-section-box w-100">
                <div class="row m0 middle-xs between-xs nowrap mb10">
                  <p v-show="!bookPublicationForm && !getCurrentProduct.promo_price" class="fs-medium-small cl-black weight-900">
                    {{ getCurrentProduct.product_type_name ? getCurrentProduct.product_type_name : (getCurrentProduct.type_id === 'subscription' || getCurrentProduct.type_id === 'bundle') && !getCurrentProduct.is_virtual_bundle ? $t('Subscription') : $t('Single edition') }}
                  </p>
                  <h4 v-show="bookPublicationForm" class="fs16 m0">
                    {{ bookPublicationForm }}
                  </h4>
                  <product-price
                    v-if="getCurrentProduct.type_id !== 'grouped'"
                    :product="getCurrentProduct"
                    :custom-options="getCurrentCustomOptions"
                    :omnibus-price="omnibusPriceMap[getCurrentProduct.sku]"
                  />
                </div>
                <div class="cl-primary variants" v-if="getCurrentProduct.type_id =='configurable'">
                  <div
                    class="error"
                    v-if="getCurrentProduct.errors && Object.keys(getCurrentProduct.errors).length > 0"
                  >
                    {{ getCurrentProduct.errors | formatProductMessages }}
                  </div>
                  <div class="h5" v-for="option in getProductOptions" :key="option.id">
                    <div class="row top-xs m0 pt15 pb40 variants-wrapper">
                      <div v-if="option.label == 'Color'">
                        <color-selector
                          v-for="filter in getAvailableFilters[option.attribute_code]"
                          :key="filter.id"
                          :variant="filter"
                          :selected-filters="getSelectedFilters"
                          @change="changeFilter"
                        />
                      </div>
                      <div class="sizes" v-else-if="option.label == 'Size'">
                        <size-selector
                          class="mr10 mb10"
                          v-for="filter in getAvailableFilters[option.attribute_code]"
                          :key="filter.id"
                          :variant="filter"
                          :selected-filters="getSelectedFilters"
                          @change="changeFilter"
                        />
                      </div>
                      <div :class="option.attribute_code" v-else>
                        <generic-selector
                          class="mr10 mb10"
                          v-for="filter in getAvailableFilters[option.attribute_code]"
                          :key="filter.id"
                          :variant="filter"
                          :selected-filters="getSelectedFilters"
                          @change="changeFilter"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <subscription v-if="getCurrentProduct.type_id === 'subscription' && !checkIfStartingNumbers" :option-id="1" :product-option="{ 1: { sku: getCurrentProduct.sku, product_id: getCurrentProduct.id }}" :product="getCurrentProduct" />
                <div class="flex between-xs middle-xs button-container">
                  <div class="quantity__wrapper">
                    <span
                      v-if="getCurrentProduct.type_id !== 'grouped' && getCurrentProduct.type_id !== 'bundle'"
                      class="cl-black h5"
                    >
                      {{ $t('Choose quantity') }}:
                    </span>
                    <product-quantity
                      class="product-quantity row m0"
                      v-if="getCurrentProduct.type_id !== 'grouped' && getCurrentProduct.type_id !== 'bundle'"
                      v-model="getCurrentProduct.qty"
                      :is-product-page="true"
                      :max-quantity="maxQuantity"
                      :loading="isStockInfoLoading"
                      :is-simple-or-configurable="isSimpleOrConfigurable"
                      :show-quantity="manageQuantity"
                      :check-max-quantity="manageQuantity"
                      @click="updateProductQty"
                      @error="handleQuantityError"
                    />
                  </div>
                  <add-to-cart
                    v-if="getCurrentProduct.type_id !== 'bundle'"
                    :product="getCurrentProduct"
                    :disabled="isAddToCartDisabled"
                    class="add-to-cart"
                  />
                </div>
              </div>
            </div>
            <div class="pb10" v-if="getCurrentProduct.type_id === 'bundle'">
              <product-links
                v-if="getCurrentProduct.type_id === 'grouped'"
                class="brdr-bottom-1 brdr-cl-matterhorn pb15"
                :products="getCurrentProduct.product_links"
              />
              <product-bundle-options
                v-if="getCurrentProduct.bundle_options && getCurrentProduct.bundle_options.length > 0"
                :product="getCurrentProduct"
              />
              <product-custom-options
                v-else-if="getCurrentProduct.custom_options && getCurrentProduct.custom_options.length > 0"
                class="brdr-bottom-1 brdr-cl-matterhorn pb15"
                :product="getCurrentProduct"
              />
            </div>
            <div class="bundle-products">
              <bundle-product v-if="getCurrentUpsellProduct" />
              <bundle-product v-if="getSecondUpsellProduct" :alternative="true" />
            </div>
            <div class="flex column">
              <shop-icons :product="getCurrentProduct" />
              <div class="shor-desc-position pb10" v-if="getCurrentProduct.short_description">
                <div v-html="getCurrentProduct.short_description" class="p10 brdr-1 brdr-15px brdr-cl-matterhorn h5" />
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
    <div
      v-observe-visibility="{
        callback: visibilityChanged,
        once: true
      }"
    >
      <product-tabs v-if="seen" class="bg-cl-main-smoke" :prod="getCurrentProduct" />
      <related-products type="crosssell" :heading="$t('See also')" :category-id="getLastCategoryId()" />
      <related-products type="related" :heading="$t('You may be interested')" :category-id="getLastCategoryId()" />
      <div class="pb20 bg-cl-main-smoke" />
      <product-meta :product="getCurrentProduct" :aggregate-rating="reviewStar" :review-count="reviewCount" :review-arr="reviewArr" :gallery="getUniqProductGallery" />
    <!-- <script v-html="getJsonLd" type="application/ld+json" /> -->
    </div>
    <div
      id="omni-chart"
      :data-sku="getCurrentProduct.sku"
      :data-chart="omnibusConfig.key"
      :data-id="omnibusConfig.key"
      :data-color="omnibusConfig.color"
      :data-font="omnibusConfig.font"
      :data-endpoint="omnibusConfig.url"
    />
  </div>
</template>

<script>
import i18n from '@vue-storefront/i18n'
import VueOfflineMixin from 'vue-offline/mixin'
import config from 'config'
import AddToCart from 'theme/components/core/AddToCart.vue'
import GenericSelector from 'theme/components/core/GenericSelector'
import ColorSelector from 'theme/components/core/ColorSelector.vue'
import SizeSelector from 'theme/components/core/SizeSelector.vue'
// import ProductAttribute from 'theme/components/core/ProductAttribute.vue'
import ProductQuantity from 'theme/components/core/ProductQuantity.vue'
import ProductLinks from 'theme/components/core/ProductLinks.vue'
import { quickSearchByQuery } from '@vue-storefront/core/lib/search'
import { createLoadReviewsQuery } from '@vue-storefront/core/modules/review/helpers'
import ProductCustomOptions from 'theme/components/core/ProductCustomOptions.vue'
import ProductBundleOptions from 'theme/components/core/ProductBundleOptions.vue'
import ProductGallery from 'theme/components/core/ProductGallery'
import Spinner from 'theme/components/core/Spinner'
// import PromotedOffers from 'theme/components/theme/blocks/PromotedOffers/PromotedOffers'
import focusClean from 'theme/components/theme/directives/focusClean'
import LogoButton from 'theme/components/core/LogoButton.vue'
import WebShare from 'theme/components/theme/WebShare'
import BaseInputNumber from 'theme/components/core/blocks/Form/BaseInputNumber'
import AddToWishlist from 'theme/components/core/blocks/Wishlist/AddToWishlist'
// import AddToCompare from 'theme/components/core/blocks/Compare/AddToCompare'
import { mapGetters } from 'vuex'
import LazyHydrate from 'vue-lazy-hydration'
import { ProductOption } from '@vue-storefront/core/modules/catalog/components/ProductOption.ts'
import { getAvailableFiltersByProduct, getSelectedFiltersByProduct } from '@vue-storefront/core/modules/catalog/helpers/filters'
import { isOptionAvailableAsync } from '@vue-storefront/core/modules/catalog/helpers/index'
import { localizedRoute, currentStoreView } from '@vue-storefront/core/lib/multistore'
import { htmlDecode } from '@vue-storefront/core/filters'
import { ReviewModule } from '@vue-storefront/core/modules/review'
import { RecentlyViewedModule } from '@vue-storefront/core/modules/recently-viewed'
import { registerModule, isModuleRegistered } from '@vue-storefront/core/lib/modules'
import { onlineHelper, isServer, productJsonLd } from '@vue-storefront/core/helpers'
import { catalogHooksExecutors } from '@vue-storefront/core/modules/catalog-next/hooks'
import ProductPrice from 'theme/components/core/ProductPrice.vue'
import { doPlatformPricesSync } from '@vue-storefront/core/modules/catalog/helpers'
import { filterChangedProduct } from '@vue-storefront/core/modules/catalog/events'
import ShopIcons from 'theme/components/core/ShopIcons'
import { prepareRelatedQuery } from '@vue-storefront/core/modules/catalog/queries/related'
import SpecialPriceTile from 'theme/components/core/blocks/Product/SpecialPriceTile.vue'
import { fetchOmnibusPriceList, getProductsOnSaleSkus, proccessPrices } from 'theme/helpers'

const RelatedProducts = () => import(/* webpackChunkName: "vsf-related" */ 'theme/components/core/blocks/Product/Related.vue');
const ProductTabs = () => import(/* webpackChunkName: "vsf-product-tabs" */ 'theme/components/core/ProductTabs.vue');
const Breadcrumbs = () => import(/* webpackChunkName: "vsf-product-tabs" */ 'theme/components/core/Breadcrumbs.vue');
const ProductMeta = () => import(/* webpackChunkName: "vsf-product-tabs" */ 'theme/components/core/blocks/Product/ProductMeta.vue');
const BundleProduct = () => import(/* webpackChunkName: "vsf-related" */ 'theme/components/core/blocks/Product/BundleProduct.vue');
const Subscription = () => import(/* webpackChunkName: "vsf-related" */ 'theme/components/core/Subscription');

export default {
  components: {
    BundleProduct,
    AddToCart,
    // AddToCompare,
    AddToWishlist,
    Breadcrumbs,
    ColorSelector,
    GenericSelector,
    // ProductAttribute,
    ProductBundleOptions,
    ProductCustomOptions,
    ProductGallery,
    ProductLinks,
    LogoButton,
    // PromotedOffers,
    RelatedProducts,
    SizeSelector,
    ProductTabs,
    WebShare,
    LazyHydrate,
    ProductQuantity,
    ProductPrice,
    ProductMeta,
    ShopIcons,
    Subscription,
    SpecialPriceTile
  },
  mixins: [ProductOption],
  directives: { focusClean },
  beforeCreate () {
    registerModule(ReviewModule)
    registerModule(RecentlyViewedModule)
  },
  data () {
    return {
      seen: false,
      isBackorder: false,
      timerCount: 0,
      detailsOpen: false,
      maxQuantity: 0,
      quantityError: false,
      isStockInfoLoading: false,
      hasAttributesLoaded: false,
      manageQuantity: true,
      reviewCount: 0,
      reviewStar: 0,
      reviewArr: [],
      omnibusPriceMap: {}
    }
  },
  computed: {
    ...mapGetters({
      getProductRelated: 'product/getProductRelated',
      getCurrentCategory: 'category-next/getCurrentCategory',
      getCurrentProduct: 'product/getCurrentProduct',
      getProductGallery: 'product/getProductGallery',
      getOriginalProduct: 'product/getOriginalProduct',
      getProductLargeGallery: 'product/getProductLargeGallery',
      getCurrentProductConfiguration: 'product/getCurrentProductConfiguration',
      attributesByCode: 'attribute/attributeListByCode',
      getCurrentCustomOptions: 'product/getCurrentCustomOptions'
    }),
    isRetailPromo () {
      if (!this.getCurrentProduct.editions_qty && !['bundle', 'subscription'].includes(this.getCurrentProduct.type_id)) return false
      if (!this.getCurrentProduct.retail_price) return false
      if (Number(this.getCurrentProduct.retail_price) <= 0) return false
      return true
    },
    omnibusConfig () {
      return config.omnibus
    },
    currencyCode () {
      return currentStoreView().i18n.currencyCode
    },
    publicationFromPretier () {
      if (!this.bookPublicationForm) return
      if (this.bookPublicationForm.includes('okładka')) return 'okladkamiekka'
      else if (this.bookPublicationForm === 'audiubook') return 'audiubook'
      else if (this.bookPublicationForm === 'ebook') return 'ebook'
      else return this.bookPublicationForm
    },
    promoted () {
      let dateToCount
      if (this.getCurrentProduct.book_premiere) dateToCount = this.getCurrentProduct.book_premiere
      if (this.getCurrentProduct.shipping_schedule) dateToCount = this.nearestDate
      if (!dateToCount) return false

      let currentPromo = {}
      let isValid = false
      if (!this.dateValidator(dateToCount)) return false
      let parsedDateTo = dateToCount.split('-')
      let nowPlTime = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Warsaw' }))
      currentPromo.countDownDate = new Date(parseInt(parsedDateTo[0], 10), parseInt(parsedDateTo[1], 10) - 1, parseInt(parsedDateTo[2], 10))
      currentPromo.rawDateToCount = dateToCount
      isValid = nowPlTime < currentPromo.countDownDate
      return isValid
        ? currentPromo
        : false
    },
    nearestDate () {
      return this.getCurrentProduct.shipping_schedule
        ? this.getCurrentProduct.shipping_schedule
          .split(';')
          .filter(x => x)
          .sort((a, b) => {
            let left = new Date(a)
            let right = new Date(b)
            if (left < right) { return -1 }
            if (left > right) { return 1 }
            return 0
          })
          .find(d => new Date(d) > new Date())
        : false
    },
    listByCode () {
      return this.$store.state.attribute.list_by_code
    },
    bookPublicationForm () {
      return this.getCurrentProduct.publication_form ? this.getLabelFor('publication_form') : null
    },
    subscriptionStartingNumbers () {
      return this.$store.getters['subscription-product/getProductNumberOptions'](this.getCurrentProduct.sku)
    },
    checkIfStartingNumbers () {
      return (Array.isArray(this.subscriptionStartingNumbers) && this.subscriptionStartingNumbers.length === 0)
    },
    isBestseller () {
      return !!this.getCurrentProduct.bestseller
    },
    isOnSale () {
      return this.getCurrentProduct.special_price && parseFloat(this.getCurrentProduct.special_price) > 0
    },
    isNew () {
      const currentDate = new Date()
      // eslint-disable-next-line no-trailing-spaces
      let expireDate = this.getCurrentProduct.news_to_date 
        ? Date.parse(this.getCurrentProduct.news_to_date)
        : 'none'
      return ((expireDate !== 'none') && (currentDate.getTime() < expireDate))
    },
    getCurrentUpsellProduct () {
      return this.getProductRelated['upsell']
        ? this.getProductRelated['upsell'][0]
        : null
    },
    getSecondUpsellProduct () {
      return this.getProductRelated['upsell']
        ? this.getProductRelated['upsell'][1]
        : null
    },
    getOptionLabel () {
      return (option) => {
        const configName = option.attribute_code ? option.attribute_code : option.label.toLowerCase()
        return this.getCurrentProductConfiguration[configName] ? this.getCurrentProductConfiguration[configName].label : configName
      }
    },
    getUniqProductGallery () {
      return this.getProductGallery.reduce((unique, item) => unique.find(elem => elem.src === item.src || elem.loading === item.loading)
        ? unique
        : [...unique, item], [])
    },
    isOnline (value) {
      return onlineHelper.isOnline
    },
    getProductOptions () {
      if (
        this.getCurrentProduct.errors &&
        Object.keys(this.getCurrentProduct.errors).length &&
        Object.keys(this.getCurrentProductConfiguration).length
      ) {
        return []
      }
      return this.getCurrentProduct.configurable_options
    },
    getOfflineImage () {
      return {
        src: this.getThumbnail(this.getCurrentProduct.image, config.products.thumbnails.width, config.products.thumbnails.height),
        error: this.getThumbnail(this.getCurrentProduct.image, config.products.thumbnails.width, config.products.thumbnails.height),
        loading: this.getThumbnail(this.getCurrentProduct.image, config.products.thumbnails.width, config.products.thumbnails.height)
      }
    },
    getCustomAttributes () {
      return Object.values(this.attributesByCode || [])
        .filter(
          a => a.is_visible && a.is_user_defined && (parseInt(a.is_visible_on_front) || a.is_visible_on_front === true) && this.getCurrentProduct[a.attribute_code]
        )
        .sort((a, b) => { return a.attribute_id > b.attribute_id })
    },
    getAvailableFilters () {
      return getAvailableFiltersByProduct(this.getCurrentProduct)
    },
    getSelectedFilters () {
      return getSelectedFiltersByProduct(this.getCurrentProduct, this.getCurrentProductConfiguration)
    },
    isSimpleOrConfigurable () {
      return ['simple', 'configurable'].includes(this.getCurrentProduct.type_id)
    },
    isAddToCartDisabled () {
      if (this.getCurrentProduct.type_id === 'subscription' && !this.checkIfStartingNumbers) {
        return !(this.getCurrentProduct.product_option && this.getCurrentProduct.product_option.extension_attributes && this.getCurrentProduct.product_option.extension_attributes.starting_numbers)
      } else {
        if (this.quantityError || this.isStockInfoLoading) {
          return false
        }
        return this.isOnline && !this.maxQuantity && this.manageQuantity && this.isSimpleOrConfigurable && !this.isBackorder
      }
    },
    storeView () {
      return currentStoreView()
    },
    getJsonLd () {
      return productJsonLd(this.getCurrentProduct, this.getCurrentProductConfiguration.color && this.getCurrentProductConfiguration.color.label, this.$store.state.storeView.i18n.currencyCode, this.getCustomAttributes)
    }
  },
  async mounted () {
    await this.$store.dispatch('recently-viewed/addItem', this.getCurrentProduct)
    this.$bus.$on('product-after-load', this.reviewStars);
  },
  async asyncData ({ store, route, context }) {
    if (context) context.output.cacheTags.add('product')
    const product = await store.dispatch('product/loadProduct', { parentSku: route.params.parentSku, childSku: route && route.params && route.params.childSku ? route.params.childSku : null })
    const loadBreadcrumbsPromise = store.dispatch('product/loadProductBreadcrumbs', { product })
    if (isServer) await loadBreadcrumbsPromise
    catalogHooksExecutors.productPageVisited(product)
  },
  beforeRouteEnter (to, from, next) {
    if (isServer) {
      next()
    } else {
      next((vm) => {
        vm.$store.commit('ui/routeChanged', { to: to, from: from })
        vm.getQuantity()
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.state.product.current_bundle_options = {}
    next()
  },
  created () {
    if (this.getCurrentProduct.book_premiere || this.getCurrentProduct.shipping_schedule) {
      this.autoIncrementTimer()
      setInterval(this.autoIncrementTimer, 60000)
    }
  },
  beforeMount () {
    if (this.getCurrentProduct.type_id === 'subscription') {
      let subscriptionSku = [this.getCurrentProduct.sku]
      this.$store.dispatch('subscription-product/load', { skus: subscriptionSku })
    }
    this.reviewStars();
    this.refreshUpsell();
    this.updateOmnibusPriceMap()
    this.loadOmnibusWidget()
    this.$bus.$on('product-after-load', this.refreshUpsell);
    this.$bus.$on('product-before-load', this.resetSubDetails);
    this.$bus.$on('product-after-load', this.updateOmnibusPriceMap);
    this.$bus.$on('product-after-load', this.loadOmnibusWidget);
  },
  beforeDestroy () {
    this.$bus.$off('product-after-load', this.refreshUpsell);
    this.$bus.$off('product-before-load', this.resetSubDetails);
    this.$bus.$off('product-after-load', this.updateOmnibusPriceMap);
    this.$bus.$off('product-after-load', this.loadOmnibusWidget);
    this.resetSubDetails();
  },
  destroyed () {
    this.$bus.$off('product-after-load', this.reviewStars);
  },
  watch: {
    isOnline: {
      handler (isOnline) {
        if (isOnline) {
          this.getQuantity()
        }
      }
    }
  },
  methods: {
    loadOmnibusWidget () {
      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.id = 'omni-chart-js'
      script.onload = function () {
        window.omniChartInit()
      }
      script.src = 'https://omnibus-front.beecommerce.pl/omni-chart.js';
      document.getElementsByTagName('head')[0].appendChild(script)
    },
    async updateOmnibusPriceMap () {
      const productsInSaleSkus = getProductsOnSaleSkus([this.getCurrentProduct])
      if (!productsInSaleSkus || !productsInSaleSkus.length) return
      let omnibusPriceMap = await fetchOmnibusPriceList(productsInSaleSkus, this.currencyCode)
      if (!omnibusPriceMap) return
      omnibusPriceMap = proccessPrices(omnibusPriceMap)
      this.omnibusPriceMap = Object.assign({}, omnibusPriceMap, this.omnibusPriceMap)
    },
    visibilityChanged (isVisible, entry) {
      if (isVisible && !this.seen) {
        this.seen = true
      }
    },
    dateValidator (dateString) {
      if (!/^(\d{4})-(\d{1,2})-(\d{1,2})/.test(dateString)) return false
      let parts = dateString.split('-')
      let day = parseInt(parts[2], 10)
      let month = parseInt(parts[1], 10)
      let year = parseInt(parts[0], 10)
      if (year < 1000 || year > 3000 || month === 0 || month > 12) return false
      let monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ]
      if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) monthLength[1] = 29
      return day > 0 && day <= monthLength[month - 1];
    },
    autoIncrementTimer () {
      if (!this.promoted || !this.promoted.countDownDate) return
      let now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Warsaw' })).getTime()
      let countDownDate = this.promoted.countDownDate.getTime()
      let distance = countDownDate - now
      if (distance <= 0) return
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      if (this.getCurrentProduct.book_premiere) this.timerCount = days + 'd ' + hours + 'g ' + minutes + 'm '
      if (this.getCurrentProduct.shipping_schedule) {
        let suffix
        days === 1
          ? suffix = ' DZIEŃ'
          : suffix = ' DNI'
        this.timerCount = days + suffix + ', ' + this.promoted.rawDateToCount
      }
    },
    getLabelFor (type) {
      if (this.listByCode && this.listByCode[type]) {
        let items = this.listByCode[type].options.filter(option => option.value === String(this.getCurrentProduct.publication_form))
        return (items && items.length) && items[0].label
      }
    },
    resetSubDetails () {
      this.$store.commit('subscription-product/subscription/RESET_SUBSCRIPTION_DETAILS')
    },
    async refreshUpsell () {
      let sku = this.getCurrentProduct.product_links
        ? this.getCurrentProduct.product_links
          .filter(pl => pl.link_type === 'upsell')
          .map(pl => pl.linked_product_sku)
        : null
      let key = 'sku'

      if (sku === null || sku.length === 0) {
        this.$store.dispatch('product/related', {
          key: 'upsell',
          items: []
        })
        this.$forceUpdate()
      } else {
        let relatedProductsQuery = prepareRelatedQuery(key, sku);

        const { items } = await this.$store.dispatch('product/list', {
          query: relatedProductsQuery,
          size: 2,
          options: {
            populateRequestCacheTags: false,
            prefetchGroupProducts: false
          }
        })
        if (items.length) {
          this.$store.dispatch('product/related', {
            key: 'upsell',
            items: items
          })
        } else {
          this.$store.dispatch('product/related', {
            key: 'upsell',
            items: []
          })
        }
        this.$forceUpdate()
      }
    },
    async reviewStars (productId, approved = true, start = 0, size = 50, entityType = 'review', sort = '', excludeFields = null, includeFields = null) {
      productId = this.getOriginalProduct.id
      const query = createLoadReviewsQuery({ productId, approved })
      const reviewResponse = await quickSearchByQuery({ query, start, size, entityType, sort, excludeFields, includeFields })
      if (reviewResponse.items) {
        this.reviewStar = reviewResponse.items.map((item) => item.ratings && item.ratings.length ? item.ratings[0].value : 0)
        let notNegative = this.reviewStar.filter((item) => item > 0)
        if (notNegative.length) {
          this.reviewStar = this.reviewStar.reduce((a, b, index) => a + b, 0) / notNegative.length
        } else {
          this.reviewStar = 0
        }
        this.reviewArr = reviewResponse.items
        this.reviewCount = reviewResponse.items.length
      }
    },
    updateProductQty (qty) {
      this.getCurrentProduct.qty = qty
    },
    showDetails (event) {
      this.detailsOpen = true
      event.target.classList.add('hidden')
    },
    notifyOutStock () {
      this.$store.dispatch('notification/spawnNotification', {
        type: 'error',
        message: this.$t(
          'The product is out of stock and cannot be added to the cart!'
        ),
        action1: { label: this.$t('OK') }
      })
    },
    notifyWrongAttributes () {
      this.$store.dispatch('notification/spawnNotification', {
        type: 'warning',
        message: this.$t(
          'No such configuration for the product. Please do choose another combination of attributes.'
        ),
        action1: { label: this.$t('OK') }
      })
    },
    async changeFilter (variant) {
      const selectedConfiguration = Object.assign({ attribute_code: variant.type }, variant)
      await filterChangedProduct(selectedConfiguration, this.$store, this.$router)
      this.getQuantity()
    },
    openSizeGuide () {
      this.$bus.$emit('modal-show', 'modal-sizeguide')
    },
    getLastCategoryId () {
      let productCategories = this.getCurrentProduct.category && this.getCurrentProduct.category.map(c => c.category_id)
      return productCategories && productCategories.length ? productCategories.slice(-1)[0] : 0
    },
    isOptionAvailable (option) { // check if the option is available
      const currentConfig = Object.assign({}, this.getCurrentProductConfiguration)
      currentConfig[option.type] = option
      return isOptionAvailableAsync(this.$store, { product: this.getCurrentProduct, configuration: currentConfig })
    },
    async getQuantity () {
      if (this.isStockInfoLoading) return // stock info is already loading
      this.isStockInfoLoading = true
      try {
        if (config.products.alwaysSyncPricesClientSide) {
          doPlatformPricesSync([this.getCurrentProduct]);
        }
        const res = await this.$store.dispatch('stock/check', {
          product: this.getCurrentProduct,
          qty: this.getCurrentProduct.qty
        })
        this.manageQuantity = res.isManageStock
        this.maxQuantity = res.isManageStock ? res.qty : null
        this.isBackorder = res.isBackorder
      } finally {
        this.isStockInfoLoading = false
      }
    },
    handleQuantityError (error) {
      this.quantityError = error
    }
  },
  metaInfo () {
    const storeView = currentStoreView()
    return {
      link: [
        {
          rel: 'canonical',
          href: config.server.hostName + localizedRoute('/' + this.getCurrentProduct.url_path)
        },
        {
          rel: 'preload',
          as: 'image',
          href: this.getProductGallery[0] && this.getProductGallery[0].src
        },
        {
          type: 'text/css',
          rel: 'stylesheet',
          href: config.omnibus.widgetUrl + `/omni-chart.min.css`
        }
      ],
      title: htmlDecode(this.getCurrentProduct.meta_title || this.getCurrentProduct.name),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.getCurrentProduct.meta_description ? htmlDecode(this.getCurrentProduct.meta_description) : htmlDecode(this.getCurrentProduct.description).replace(/<[^>]+>/g, ' ').replace(/\s{2,10}/g, ' ')
        },
        {
          property: 'og:type',
          content: 'product'
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: this.getCurrentProduct.meta_title ? htmlDecode(this.getCurrentProduct.meta_title) : htmlDecode(this.getCurrentProduct.name)
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: this.getCurrentProduct.meta_description ? htmlDecode(this.getCurrentProduct.meta_description) : htmlDecode(this.getCurrentProduct.description).replace(/<[^>]+>/g, ' ').replace(/\s{2,10}/g, ' ')
        },
        {
          vmid: this.getCurrentProduct.url_path ? 'og:url' : '',
          property: this.getCurrentProduct.url_path ? 'og:url' : '',
          content: this.getCurrentProduct.url_path ? htmlDecode(config.server.hostName + '/' + this.getCurrentProduct.url_path) : ''
        },
        this.getProductGallery && this.getProductGallery.length && this.getProductGallery[0].src ? {
          property: 'og:image',
          content: htmlDecode(this.getProductGallery[0].src)
        } : '',
        this.getProductGallery && this.getProductGallery.length && this.getProductGallery[0].src ? {
          property: 'og:image:width',
          content: '600'
        } : '',
        this.getProductGallery && this.getProductGallery.length && this.getProductGallery[0].src ? {
          property: 'og:image:height',
          content: '744'
        } : '',
        {
          property: this.getCurrentProduct.url_path ? 'og:brand' : '',
          content: this.getCurrentProduct.category && this.getCurrentProduct.category.length && this.getCurrentProduct.category[0].name ? htmlDecode(this.getCurrentProduct.category[0].name) : ''
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-primary: color(primary);
$color-tertiary: color(tertiary);
$color-secondary: color(secondary);
$color-white: color(white);
$burnt-sienna: color(burnt-sienna);
$bg-secondary: color(secondary, $colors-background);
$main-gray: color(main-gray);
$main: color(main);
$forest-green: color(forest-green);

.shor-desc-position {
  @media (max-width: 767px) {
    order: -1;
  }
}

.tile {
  position: absolute;
  z-index: 1;
  @media (max-width: 767px) {
    left: 5px;
    top: 50px;
  }
  &__label {
    color: white;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 25px;
    width: max-content;
    @media (max-width: 767px) {
      font-size: 14px;
      padding: 3px 12px;
    }
 }
 .special {
   background: #ff1919;
 }
  .sale {
    background: $burnt-sienna;
  }
  .bestseller {
    background: $forest-green;
  }
  .retailPromo {
    background: $main;
  }
  .new {
    background: $main;
  }
}
.col-tablet {
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px)  {
    flex-basis: 100%;
    max-width: 100%;
  }
}

.product {
  &__add-to-compare {
    display: none;
    @media (min-width: 767px) {
      display: block;
    }
  }
}
.product-container{
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px), (max-width: 767px) {
    margin: 0;
    padding: 0;
  }
}
.breadcrumbs {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 1;
  color: #1396EC;
}

.error {
  color: red;
  font-weight: bold;
  padding-bottom: 15px;
}
.data {
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px)  {
    margin: 0;
    border-bottom: 1px solid #F2F3F4;
    padding: 0 10px;
  }
  @media (max-width: 767px) {
    border-bottom: 1px solid $bg-secondary;
    padding: 0 10px;
  }
}

.image {
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px), (max-width: 1023px) {
    // margin-bottom: 20px;
    padding: 0;
    background-color: $main-gray;
  }
}

.wishlist-btn {
  position: absolute;
  right: -20px;
  top: 10px;
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px), (max-width: 767px) {
    right: 0;
    margin-top: 5px;
  }
}

.name-wrapper {
  @media (max-width: 767px) {
    width: 80%;
  }
}

.product-name {
  font-size: 28px;
  @media (max-width: 767px) {
    font-size: 16px;
  }
}

.button-container {
  .quantity__wrapper {
    display: flex;
    flex-direction: row;
    -ms-flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    .product-quantity {
      margin: 0 10px;
    }
    @media(max-width: 767px) {
      width: 100%;
    }
  }
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px)  {
    display: flex;
    flex-direction: column;
    -ms-flex-direction: column;
    align-items: flex-end;
    .add-to-cart {
      margin-top: 10px;
    }
  }
  @media(max-width: 767px) {
    flex-direction: column;
    -ms-flex-direction: column;
    .product-quantity {
      margin: 0;
    }
  }
}

.add-to-cart {
  max-width: 180px;
  width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  // min-width: 200px;
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px)  {
    max-width: initial;
    width: 100%;
    flex-basis: 100%;
    max-width: 100%;
    margin-top: 10px;
  }
  @media(max-width: 767px) {
    max-width: initial;
    width: 100%;
    margin-top: 10px;
  }
}

.variants-wrapper {
  @media (max-width: 767px) {
    padding-bottom: 30px;
  }

  .sizes {
    @media (max-width: 767px) {
      width: 100%;
    }
  }

  .size-guide {
    height: 40px;
    @media (max-width: 767px) {
      width: 100%;
      margin-left: 0;
    }
  }
}

.product-top-section {
  background: rgb(224,242,250);
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px), (max-width: 767px) {
    background: none;
    padding: 0;
    background-color: $color-white;
  }
}

.add-to-buttons {
  @media (max-width: 767px) {
    padding-top: 30px;
    margin-bottom: 40px;
  }
}

.details {
  @media (max-width: 767px) {
    padding: 50px 15px 15px;
  }
}

.details-title {
  padding: 0 8px;

  @media (max-width: 767px) {
    font-size: 18px;
    margin: 0;
  }
}

.details-wrapper {
  @media (max-width: 767px) {
    position: relative;
    max-height: 140px;
    overflow: hidden;
    transition: all 0.3s ease;
    font-size: 14px;
  }

  &--open {
    max-height: none;
  }
}

.details-overlay {
  @media (max-width: 767px) {
    position: absolute;
    height: 75%;
    bottom: 0;
    left: 0;
    width: 100%;
    margin: 0;
    cursor: pointer;
    background: linear-gradient(rgba($color-white, 0), rgba($color-white, 1));
    &.hidden {
      display: none;
    }
  }
}

.action {
  &:hover {
    color: $color-tertiary;
  }
}

.attributes {
  list-style-type: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.product-image {
  mix-blend-mode: multiply;
  width: 460px;
}

.web-share {
  float: right;
}
.promoted-badge {
  width: 100%;
  flex-wrap: nowrap;
  border-radius: 30px;
  margin-left: 0;
  margin-right: 0;
  justify-content: space-between;
  .counter {
    text-align: center;
    color: white;
    background-color: #000;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .promoted-countdown {
    margin: 0;
  }
  .promoted-title {
    margin: 11px 0;
    font-size: 14px;
    text-transform: uppercase;
    color: white;
    padding-left: 20px;
    font-weight: 400;
    letter-spacing: 1px;
  }
}
.bookPublicationFormImage {
  background-color: white;
  border-radius: 15px;
  display: flex;
  height: fit-content;
  border: 1.5px solid #CFCFCF;
  margin-right: 10px;
  @media (min-width: 768px) and (max-width: 1125px) {
    display: none;
  }
  @media (max-width: 767px) {
    display: none;
  }
}
.border-section-box {
  > div.nowrap {
    @media (max-width: 767px) {
      flex-wrap: wrap;
    }
    h4 {
      @media (max-width: 767px) {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
